import {
  enableProdMode,
  inject,
  runInInjectionContext,
} from '@angular/core';
import {
  platformBrowserDynamic,
} from '@angular/platform-browser-dynamic';
import {
  RulesEngineRunnerService,
} from '@o3r/rules-engine';
import {
  clearAllSessionStorage,
} from '@refx/shared-common';
import {
  FunctionalContentOverrideActionHandler,
} from '@refx/shared-services';
import {
  isCurrentSessionValid,
} from '@refx/ssci-common';
import cssVars from 'css-vars-ponyfill';
import {
  AppModule,
} from './app/app.module';
import {
  environment,
} from './environments/index';

cssVars({
  onlyLegacy: true,
  watch: true
});

if (environment.production) {
  enableProdMode();
}

if (!Element.prototype.matches) {
  Element.prototype.matches = (Element.prototype as any).msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!isCurrentSessionValid()) {
  clearAllSessionStorage();
}

document.addEventListener('DOMContentLoaded', () =>
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((m) => {
      runInInjectionContext(m.injector, () => {
        const rulesEngineRunnerService = inject(RulesEngineRunnerService);
        rulesEngineRunnerService.actionHandlers.add(inject(FunctionalContentOverrideActionHandler));
      });
    })
);
